import { render } from "./UsersAdmin.vue?vue&type=template&id=ac0d5306&scoped=true"
import script from "./UsersAdmin.vue?vue&type=script&lang=js"
export * from "./UsersAdmin.vue?vue&type=script&lang=js"

import "./UsersAdmin.vue?vue&type=style&index=0&id=ac0d5306&scoped=true&lang=less"

import exportComponent from "D:\\Tsubakimoto\\Tsubakimoto_mvc\\Tsubakimoto\\tsubakimoto_fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac0d5306"]])

export default __exports__